<div class="content">

  <a *ngIf="userSettingsRouterLink"
     [routerLink]="userSettingsRouterLink"
     class="item"
     title="User Settings"
     i18n-title="@@User_Settings"
     pplPopoverClose>
    <ng-container *ngTemplateOutlet="userInfo"></ng-container>
  </a>

  <a *ngIf="userSettingsUrl"
     [href]="userSettingsUrl"
     class="item"
     target="_blank"
     title="User Settings"
     i18n-title="@@User_Settings"
     pplPopoverClose>
    <ng-container *ngTemplateOutlet="userInfo"></ng-container>
  </a>

  <ng-template #userInfo>
    <img *ngIf="userProfile.pictureUrl"
         [src]="userProfile.pictureUrl"
         [alt]="userProfile | pplName"
         class="avatar"/>
    <div *ngIf="!userProfile.pictureUrl"
         class="avatar">
      <ppl-icon svgIcon="contact-avatar"></ppl-icon>
    </div>
    <div class="info">
      <div class="name">{{userProfile | pplName}}</div>
      <div class="text">{{userProfile.email}}</div>
    </div>
    <ppl-icon svgIcon="color-space-settings" class="item-top-icon" width="16px" height="16px"></ppl-icon>
  </ng-template>

  <a *ngIf="currentSpace && selectSpaceUrl"
     [href]="selectSpaceUrl"
     class="item item--space"
     title="Switch Space"
     i18n-title="@@Switch_Space"
     pplPopoverClose>
    <ng-container *ngTemplateOutlet="spaceInfo"></ng-container>
  </a>

  <div *ngIf="currentSpace && !selectSpaceUrl"
       class="item item--space">
    <ng-container *ngTemplateOutlet="spaceInfo"></ng-container>
  </div>

  <ng-template #spaceInfo>
    <img *ngIf="currentSpace.pictureUrl"
         [src]="currentSpace.pictureUrl"
         [alt]="currentSpace.name"
         class="avatar"/>
    <div *ngIf="!currentSpace.pictureUrl"
         class="avatar">
      <ppl-icon svgIcon="pipeline-avatar"></ppl-icon>
    </div>

    <div class="info">
      <div class="name">{{currentSpace.name}}</div>
      <div class="text" i18n="@@Current_Space">Current space</div>
    </div>

    <ppl-icon *ngIf="selectSpaceUrl" svgIcon="color-switch-space-blue" class="item-top-icon" width="16px" height="16px"></ppl-icon>
  </ng-template>

  <div class="actions">
    <button [style.visibility]="currentSpace && enableSpaceSettings ? 'visible' : 'hidden'"
            (click)="openSpaceSettings.emit(true)"
            pplButton
            pplButton1
            pplButtonSmall
            pplPopoverClose>
      <ppl-icon svgIcon="color-space-settings"
                width="16px"
                height="16px"></ppl-icon>
      <ng-container i18n="@@Settings">Settings</ng-container>
    </button>

    <a [href]="logoutHref"
       pplButton
       pplButton6
       pplButtonSmall
       pplPopoverClose>
      <ppl-icon svgIcon="color-sign-out"
                width="16px"
                height="16px"></ppl-icon>
      <ng-container i18n="@@Sign_Out">Sign Out</ng-container>
    </a>
  </div>
</div>
